module.exports = __webpack_public_path__ + "img/mountains-water.6a78a770.jpg";